import { UserIcon } from '@/components/ui/user-icon/UserIcon';

import { PostAuthor } from './PostAuthor';

export const Post = ({
  id,
  name,
  content,
  createdAt,
  updatedAt,
}: {
  id?: string;
  name: string | null;
  content?: string;
  createdAt: string;
  updatedAt: string | null;
}) => {
  return (
    <div className="border-wrapper" id={id}>
      <div className="border-wrapper__box">
        <div className="post">
          <div className="post__icon">
            <UserIcon />
          </div>

          <div className="post__body">
            <div className="post__body-author">
              <PostAuthor
                name={name ?? ''}
                createdAt={createdAt}
                updatedAt={updatedAt}
              />
            </div>

            <div
              dangerouslySetInnerHTML={{ __html: content ?? '' }}
              className="post__body-content"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
